import { Category, ElementsType } from './Category.interface';

export class CategoryModel implements Category {
  id: number;
  parentId?: number;
  title: string;
  slug: string;
  servicesCount?: number;
  children: number[] | [];
  routePath: string;
  elementsType?: ElementsType;
  iconId?: number;
  iconActiveId?: number;

  constructor(data: any) {
    this.id = data.id ? data.id : null;
    this.servicesCount = data.entity.servicesCount
      ? data.entity.servicesCount
      : 0;
    this.parentId = data.parentId ? data.parentId : null;
    this.title = data.entity && data.entity.title ? data.entity.title : '';
    this.slug = data.entity && data.entity.slug ? data.entity.slug : '';
    this.children = data.children && data.children.length ? data.children : [];
    this.routePath = data.routePath ? data.routePath : '';
    this.elementsType = data.elementsType ? data.elementsType : '';
    this.iconId = data.entity.iconId || 0;
    this.iconActiveId = data.entity.iconActiveId || 0;
  }
}
